
import {
	addMemberToOrganisationController,
	View,
} from '@/modules/organisation-members/components/AddMemberToOrganisation.controller';
import ListAction from '@/lib/components/ListActions/ListAction';
import ListActionForm from '@/lib/components/ListActions/ListActionForm.vue';
import CloseIcon from '@/lib/components/ListActions/Partials/CloseIcon.vue';
import { Modal } from 'vue-bootstrap';
import OrganisationSelector from '@/modules/organisations/components/OrganisationSelector.vue';
import { useController } from '@/domain/services/Composer';

export default {
	components: { OrganisationSelector, CloseIcon, ListActionForm, Modal },
	extends: ListAction,
	setup: useController(addMemberToOrganisationController, 'AddMemberToOrganisationController') as () => View,
};
